import { render, staticRenderFns } from "./_contractsTableObserved.vue?vue&type=template&id=bf951846"
import script from "./_contractsTableObserved.vue?vue&type=script&lang=js"
export * from "./_contractsTableObserved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports